import { Box, Stack, Typography } from '@mui/material';
import { FunctionField } from 'react-admin';
import { DrawerLink } from '@/components/global/drawers/DrawerLink.jsx';
import React from 'react';
import { styled } from '@mui/material/styles';
import { aliasToString } from '@/helpers/device/softwareHelpers.js';

const StyledBox = styled(Box)({
    display: 'flex',
    alignItems: 'baseline',
    '&:first-of-type': {
        marginRight: '4px',
        '&::after': {
            content: '","',
        },
    },
    '& .MuiTypography-caption': {
        fontSize: '14px',
        lineHeight: '20px',
        letterSpacing: '-0.14px',
    },
    '& a': {
        fontWeight: '600 !important',
        paddingLeft: '3px',
    },
});

const GroupSoftwareField = () => {
    return (
        <FunctionField
            render={record => (
                <Stack sx={{ display: 'flex', flexDirection: 'row' }}>
                    <StyledBox>
                        <Typography variant='caption'>MCU:</Typography>
                        {record?.targetSoftwareMcuId && (
                            <DrawerLink
                                resource='software'
                                action='show'
                                source={record?.targetSoftwareMcu?.softwareId}
                                label={aliasToString(record?.targetSoftwareMcu)}
                                relative
                            />
                        )}
                    </StyledBox>
                    <StyledBox>
                        <Typography variant='caption'>SOC:</Typography>
                        {record?.targetSoftwareSocId && (
                            <DrawerLink
                                resource='software'
                                action='show'
                                source={record?.targetSoftwareSoc?.softwareId}
                                label={aliasToString(record?.targetSoftwareSoc)}
                                relative
                            />
                        )}
                    </StyledBox>
                </Stack>
            )}
        />
    );
};

export default GroupSoftwareField;
